export default "https://assets.egbcdn.net/assets/packs/_/images/app/ios/ios-en-3-9f65025a67c2a00efd7060e5f88b1fd4.png";